(function () {
  var observer;

  function loadNextPage(sentinel) {
    var nextUrl = sentinel.getAttribute('data-next-url');
    var sectionId = sentinel.getAttribute('data-section-id');
    if (!nextUrl) return;

    if (observer) observer.unobserve(sentinel);

    var separator = nextUrl.indexOf('?') === -1 ? '?' : '&';
    var fetchUrl = nextUrl + separator + 'section_id=' + sectionId;

    fetch(fetchUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var currentGrid = document.querySelector('#product-grid[data-id="' + sectionId + '"]');
        var newItems = doc.querySelectorAll('#product-grid[data-id="' + sectionId + '"] > li');

        if (currentGrid) {
          newItems.forEach(function (item) {
            currentGrid.appendChild(item);
          });
        }

        var newSentinel = doc.querySelector(
          '[data-suroor-infinite-scroll][data-section-id="' + sectionId + '"]'
        );

        if (newSentinel) {
          sentinel.replaceWith(newSentinel);
          observeSentinel(newSentinel);
        } else {
          sentinel.remove();
        }
      })
      .catch(function () {
        sentinel.remove();
      });
  }

  function observeSentinel(sentinel) {
    if (!observer) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              loadNextPage(entry.target);
            }
          });
        },
        { rootMargin: '400px' }
      );
    }
    observer.observe(sentinel);
  }

  document.querySelectorAll('[data-suroor-infinite-scroll]').forEach(observeSentinel);
})();
